import styled, { css } from 'styled-components'
import { ThemeSelectors, TypeSmart } from '@at/design-system-foundation'
import { BREAKPOINTS } from '@at/window-utils'

export const NewStyledDealerLocationText = styled(TypeSmart)`
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => theme.color.text.default};
    border-radius: 4px;

    display: flex;
    gap: 4px;
    margin-top: 0;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 10px;

    @media (min-width: ${BREAKPOINTS.MEDIUM}px) {
        margin-top: 8px;
    }
`
export const StyledDealerLocationTown = styled.span`
    ${({ theme }) => {
        return css`
            white-space: nowrap;
            margin-right: ${ThemeSelectors.getLegacyGridUnit(theme) * 0.5}px;
        `
    }}
`
